// extracted by mini-css-extract-plugin
module.exports = {"blockquote":"Blockquote_blockquote__oFdyX"};